import { useServices } from 'hooks';
import { useMutation } from '@tanstack/react-query';

type RequestDeletionMutationInput = {
	email: string;
};

export const useRequestDeletion = () => {
	const { api } = useServices();

	const { mutateAsync: doRequestDeletionAsync } = useMutation({
		mutationFn: ({ email }: RequestDeletionMutationInput) => {
			return api.requestDeletion(email);
		},
	});

	return { doRequestDeletionAsync };
};
